export const QUERY_KEYS = {
  SST_CONVERSION: 'SST_CONVERSION',
  CONVERSATIONS: 'CONVERSATIONS',
  CONVERSATION: 'CONVERSATION',
  ADMIN_EVENTS: 'ADMIN_EVENTS',
  ADMIN_INVENTORY_HEALTH: 'ADMIN_INVENTORY_HEALTH',
  ADMIN_MIGRATIONS: 'ADMIN_MIGRATIONS',
  ADMIN_WIPE: 'ADMIN_WIPE',
} as const;
